class exports.Layer_Shapefile_Point extends Handler
    constructor: () ->
        super()
        @layoutSelector = null

    # Slider handling via mfSlider directive instead of init()
    onSlider: (ev, ui) =>
        @setOpacity ui.value

    init: () ->
        # @slider = @parent.sidebar_row.find('.shapefile-slider')
        # @slider.on 'slide',(e,ui) =>
        #         @setOpacity(ui.value)

        # console.log @loadLayoutPostOptions
        @layer_id = @loadLayoutPostOptions.id
        $.post 'backend/grower/layers/shapefile/get-bounds-and-binning', id: @layer_id, (response) =>
            if @__destroyed
                return null

            @bounds = new L.LatLngBounds [
                [response.data.bounds.south, response.data.bounds.west],
                [response.data.bounds.north, response.data.bounds.east]
            ]

            @binning = response.data.binning
            @infoWindow = new L.Popup()


            App.map.on 'zoomend', @refresh

            @refresh()



    refresh: () =>
        # @slider.slider 'disable'
        if App.map.getZoom() < 14
            return


        url = "#{Config.get('gis_server')}/point-data-raster?id=#{@layer_id}&bin_attr=#{@binning}&zoom_level=" + App.map.getZoom()
        if @overlay?
            App.map.removeLayer @overlay
        if @_clickListener?
            App.map.off 'click', @_clickListener

        @overlay = new L.ImageOverlay url, @bounds
        @overlay.addTo App.map

        # kind of a hack to make the image look clickable
        L.DomUtil.addClass @overlay._image, 'clickable'

        @_clickListener = (e) =>
            if not @bounds.contains e.latlng
                return

            App.map.closePopup @infoWindow
            $.post 'backend/grower/layers/shapefile/get-image-clicked-data',
                id: @layer_id
                lat: e.latlng.lat
                lng: e.latlng.lng
                sort_attr: @binning
                (response) =>
                    if response.status?.type isnt 'success'
                        return

                    @infoWindow.setContent response.view
                    @infoWindow.setLatLng [ response.data.lat, response.data.lng ]
                    App.map.openPopup @infoWindow
                    #@infoWindow.open(App.map)

        App.map.on 'click', @_clickListener


    setOpacity: (v) ->
        if @overlay?
            #console.log @overlay.getOpacity()
            @overlay.setOpacity parseFloat((v / 100).toFixed(2))



    destroy: () ->
        # @slider.slider 'disable'
        # @slider.off 'slide'
        if @overlay?
            App.map.removeLayer @overlay

        App.map.off 'click', @_clickListener
        App.map.off 'zoomend', @refresh

        super()

        # if point based...
            # get the bounds of the layer.
            # make a call to create the layer.
            # display!
        # else
            # just display it using KML magix. (or geojson? doesn't REALLY matter...)
